import { ReactNode } from 'react'

import { SelectedElement } from '../Picker/SelectedElement'
import { PickerItem } from '../types'
import { BaseCheckPickerProps } from './CheckPicker.types'

interface SelectedDisplayParams<Item extends PickerItem> {
  selectedValues: Item['value'][]
  selectedItems: Item[]
  placeholder: ReactNode
  prefix: (className: string) => string
  renderValue?: BaseCheckPickerProps<Item>['renderValue']
}

export const getSelectedDisplay = <Item extends PickerItem>({
  selectedValues,
  selectedItems,
  placeholder,
  prefix,
  renderValue,
}: SelectedDisplayParams<Item>) => {
  const selectedElement = selectedItems.length ? (
    <SelectedElement selectedItems={selectedItems} prefix={prefix} />
  ) : (
    placeholder
  )

  if (!selectedValues.length || !renderValue) {
    return { selectedElement, hasValue: selectedItems.length > 0 }
  }

  const renderedValue = renderValue(selectedValues, selectedItems, selectedElement)
  return { selectedElement: renderedValue, hasValue: renderedValue != null }
}
